import { createAction } from '../stateReducer/util';
export const setDataGridState = createAction('setDataGridState');
export const setSort = createAction('setSort');
export const initPagination = createAction('initPagination');
export const resetPagination = createAction('resetPagination');
export const goToPage = createAction('goToPage');
export const setPageSize = createAction('setPageSize');
export const registerFilter = createAction('registerFilter');
export const updateFilter = createAction('updateFilter', (key, value) => ({
  key,
  value
}));